"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
const react_1 = __importDefault(require("react"));
const theme_ui_1 = require("theme-ui");
const useInheritedStyles_1 = require("../../hooks/useInheritedStyles");
const Theme_1 = require("../Theme");
const getClassNameWithReset = (className) => Theme_1.resetClassName + (className ? ` ${className}` : "");
exports.Box = react_1.default.forwardRef((_a, ref) => {
    var { className, sx: sxInitial } = _a, props = __rest(_a, ["className", "sx"]);
    const sx = Object.assign({ fontFamily: "body" }, sxInitial);
    const { newInheritedStylesContext, mergedSx } = (0, useInheritedStyles_1.useMergeStyles)(sx);
    return (react_1.default.createElement(useInheritedStyles_1.InheritedStylesProvider, { styleContext: newInheritedStylesContext },
        react_1.default.createElement(theme_ui_1.Box, Object.assign({ className: getClassNameWithReset(className), ref: ref, sx: mergedSx }, props))));
});
exports.Box.displayName = "Box";
//# sourceMappingURL=Box.js.map